export interface INotification {
  id?: string;
  level: string;
  message: string;
  detailedMessage?: string;
}

export interface INotificationWithTimestamp extends INotification {
  timestamp: number;
  id: string;
  detailedData?: unknown;
}

export interface INotificationState {
  allNotifications: INotificationWithTimestamp[];
  recentNotification: INotificationWithTimestamp | Record<string, never>;
  byLevel: Record<string, INotificationWithTimestamp[]>;
  lastSuccessNotification: number;
}

export const notificationsInitialState: INotificationState = {
  allNotifications: [],
  recentNotification: {},
  byLevel: {},
  lastSuccessNotification: -1,
};
